import React from 'react'
import clsx from "clsx";
import {SidebarOption} from "components";
import {Drawer, List} from "@material-ui/core";

const DesktopDrawer = (props) => {
    const {classes, directory, subTabs, handleCollapse, handleNavigate, open} = props
    return (
        <Drawer variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}>
            <div className={classes.toolbarMargin}/>
            {   /*==========    Sidebar Options     ==========*/}
            <List>
                {directory && directory.map(({id, label, icon, slug, total}) =>
                    <SidebarOption key={id}
                                   Icon={icon}
                                   title={label}
                                   number={total}
                                   subTabs={subTabs}
                                   navigate={`/${slug}`}
                                   handleCollapse={handleCollapse}
                                   handleNavigate={handleNavigate}
                    />
                )}
            </List>
        </Drawer>
    )
};

export default DesktopDrawer;